import Loading from '../misc/Loading';
import React from 'react';
import StockModel from './../../../../model/stock';
import _ from 'lodash';
import {
  PanelGroup,
  Panel
} from 'react-bootstrap';
import cookie from 'js-cookie';
import {NavLink as Link} from 'react-router-dom';
import ValidationError from '../../../../model/error/ValidationError';
import StockListPanel from './StockListPanel.js';
import withRouter from '/src/components/misc/withRouter';
import {mapMakeToMakeId} from '/src/components/misc/utils';

import './StockList.scss';

const errorToMessage = (error) => {
  console.error(error);
  if (error instanceof ValidationError) {
    return 'Bilen validerer ikke og kan dermed ikke publiseres. Sjekk at alle påkrevede felter er fylt ut med gyldige verdier og prøv igjen.';
  }

  return 'En ukjent feil inntraff ved behandling av bilen og handlingen kunne dermed ikke fullføres.';
};

class StockContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      makeId: null,
      cars: null,
      modified: false,
      working: false,
      workingId: null,
      activeKey: null,
      error: null
    };

    this.handleSelectPanel = this.handleSelectPanel.bind(this);
    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.updateCarsInState = this.updateCarsInState.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.make) {
      this.fetchCars(this.props.match.params.make);
    }
  }

  UNSAFE_componentWillReceiveProps(next) { // eslint-disable-line camelcase
    if (next.match.params.make) {
      this.setState({
        makeId: null,
        cars: null
      });
      this.fetchCars(next.match.params.make);
    }
  }

  fetchCars(make) {
    const makeId = mapMakeToMakeId[make];
    StockModel.getByMake(makeId, 2).then((cars) => {
      document.title = `Admin - Biler på lager - ${make}`;
      // Try to fect active tab from cookie
      let activeKey = null;
      const cookieTab = cookie.get(`mgStockTab-${this.props.match.params.make}`);
      if (cookieTab) {
        activeKey = parseInt(cookieTab, 10);
      }

      const carsGrouped = this.groupCarsByModel(cars);
      this.setState({
        cars: carsGrouped,
        makeId: makeId,
        make: _.capitalize(make),
        activeKey: activeKey,
        working: false,
        workingId: null
      });
    }).catch(() => {
      this.setState({
        error: 'Kunne ikke hente biler på lager',
        working: false,
        workingId: null
      });
    });
  }

  groupCarsByModel(cars) {
    const group = {};
    cars.forEach((car) => {
      const model = car.model;
      if (!group[model.id]) {
        group[model.id] = {
          name: car.model.name,
          cars: []
        };
      }

      group[model.id].cars.push(car);
    });
    return group;
  }

  updateCarsInState(newCarObj, modelId) {
    const newCars = this.state.cars;
    const model = newCars[modelId];

    model.cars = model.cars.map((car) => {
      if (newCarObj.id === car.id) {
        return newCarObj;
      }
      return car;
    });

    newCars[modelId] = model;
    this.setState({
      cars: newCars,
      working: false,
      workingId: null
    });
  }

  handlePublish(car, modelId) {
    const make = this.state.make.toLowerCase();
    this.setState({
      working: true,
      workingId: car.id
    });
    StockModel.publish(car.id, 2).then((result) => {
      if (result) {
        this.updateCarsInState(result, modelId);
      } else {
        this.fetchCars(make);
      }
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false,
        workingId: null
      });
    });
  }

  handleUnpublish(car, modelId) {
    const make = this.state.make.toLowerCase();
    this.setState({
      working: true,
      workingId: car.id
    });
    StockModel.unpublish(car.id, 2).then((result) => {
      if (result) {
        this.updateCarsInState(result, modelId);
      } else {
        this.fetchCars(make);
      }
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false,
        workingId: null
      });
    });
  }

  handleSelectPanel(activeKey) {
    const cookieName = `mgStockTab-${this.props.match.params.make}`;
    cookie.set(cookieName, activeKey, {path: '/'});

    this.setState({
      activeKey
    });
  }

  render() {
    if (this.state.cars) {
      const models = Object.values(this.state.cars);

      const lastModified = (models.length > 0) ? models[0].cars[0].modified : '-';

      return (
        <section className="mg-cars-in-stock">
          <div className="mf-model">
            <ol className="breadcrumb mf-margin-top-20">
              <li><Link to="/">Forsiden</Link></li>
              <li className="active">Biler på lager</li>
            </ol>
            <h1 className="page-header">Biler på lager <span className="text-muted"> - {this.state.make}</span></h1>
          </div>

          <div className="last-modified">
            <h4>Sist oppdatert: <strong>{lastModified}</strong></h4>
            <p className="text-info" style={{marginBottom: '15px'}}>Her finnes info om <strong>biler på lager i Drammen.</strong></p>
          </div>

          <PanelGroup
            accordion
            id="models"
            className="mg-panel-group"
            onSelect={this.handleSelectPanel}
            activeKey={this.state.activeKey}
          >
            {models.map((model, index) => {
              const modelId = model.cars[0].model.id;
              return (
                <Panel
                  eventKey={index}
                  className="mg-panel"
                  key={index}
                  id={`model-panel-${modelId}`}
                >
                  <Panel.Heading className="mg-panel-heading">
                    <Panel.Title toggle componentClass='h4'>
                      <span>{model.name} ({model.cars.reduce((total, s) => s.stock + total, 0)})</span>
                      <i className="fa fa-chevron-down"></i>
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Collapse
                    data-model={modelId}
                  >
                    {this.state.activeKey === index &&
                      <StockListPanel
                        cars={model.cars}
                        model={model.cars[0].model}
                        makeId={this.state.makeId}
                        handlePublish={this.handlePublish}
                        handleUnpublish={this.handleUnpublish}
                        workingId={this.state.workingId}
                        working={this.state.working}
                        make={this.state.make}
                      />
                    }
                  </Panel.Collapse>
                </Panel>
              );
            })}
          </PanelGroup>
        </section>
      );
    }
    return (
      <Loading title="Biler på lager" text="Laster biler på lager" />
    );
  }
}

StockContainer.defaultProps = {
  id: null
};

export default withRouter(StockContainer);
